//
// SelectionController.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "./SelectionOptions";
import "./Selection";
import "../models/data/DataValue";

var SelectionController = createModule("commons::SelectionController", [], EventDispatcher, [
    {
        SELECTION_CHANGED: 20055,
    },
    ,
    ,
    ,
    {
        getDefaultOptions: [1],
        applySelections: [0,[1],1],
        getDataValuesFromSelections: [[1],[1],7,7],
        getSelections: [[1],1],
        clearSelections: [0],
    },
    ,
    ,
]);
export default SelectionController;
